import $ from "jquery";
import { Model } from "backbone";
/* eslint-disable
    constructor-super,
    func-names,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-underscore-dangle,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let Comment;
export default Comment = (function () {
  Comment = class Comment extends Model {
    constructor(...args) {
      super(...args);
      this.recommend = this.recommend.bind(this);
      this.unrecommend = this.unrecommend.bind(this);
      this.delete = this.delete.bind(this);
      this.restore = this.restore.bind(this);
      this.remove = this.remove.bind(this);
    }

    static initClass() {
      this.prototype.urlRoot = "/comments";
    }

    // TODO: change rails routes and comments controller so we can just use
    // the restfulness of backbone instead of manually building and posting
    // to custom urls

    recommend() {
      return $.ajax({ url: this._recommendUrl(), type: "POST" });
    }

    unrecommend() {
      return $.ajax({ url: this._unrecommendUrl(), type: "DELETE" });
    }

    delete() {
      return $.ajax({
        url: this._deleteUrl(),
        type: "POST",
        dataType: "json",
        success: data => this.trigger("comment:deleted", data.message),
        error: data => this.trigger("comment:deleted:failure", data.message),
      });
    }

    restore() {
      return $.ajax({
        url: this._restoreUrl(),
        type: "POST",
        dataType: "json",
        success: data => this.trigger("comment:restored", data.message),
        error: data => this.trigger("comment:restored:failure", data.message),
      });
    }

    // For moderator comment 'removal'
    remove(serializedFormData) {
      return $.ajax({
        url: this._removeUrl(),
        type: "POST",
        dataType: "json",
        data: serializedFormData, // form.serializeArray()
        success: data => this.trigger("comment:removed", data.message),
        error: data => this.trigger("comment:removed:failure", data.message),
      });
    }

    _deleteUrl() {
      return `editorial${this.url()}/remove`;
    }

    _restoreUrl() {
      return `editorial${this.url()}/restore`;
    }

    _removeUrl() {
      return `${this.url()}/remove`;
    }

    _recommendUrl() {
      return `${this.url()}/recommends?thrust=positive`;
    }

    _unrecommendUrl() {
      return `${this.url()}/unrecommend`;
    }
  };
  Comment.initClass();
  return Comment;
}());
